import "antd/dist/antd.min.css";
import { Image, Rate, Button, InputNumber, Radio, Select } from "antd";
import React, { useEffect, useState } from "react";
import { images } from "../assets";
import { convertToVnd } from "../utils/function";
import Heading from "./Heading";
import { StarFilled } from "@ant-design/icons";
import AgentsProductItem from "./AgentsProductItem";
import APIService from "../services/APIService";
import { Option } from "antd/lib/mentions";
import { useSearchParams } from "react-router-dom";

const ListFilterAddress = [
  { value: "NEAR", lable: "Giao hàng gần nhất" },
  { value: "FAR", lable: "Giao hàng xa nhất" },
];
const ListFilterPrice = [
  { value: "ASC", lable: "Giá thấp đến cao" },
  { value: "DESC", lable: "Giá cao đến thấp" },
];
const renderRow = (title, content) => {
  return (
    <p className="flex flex-row font-light">
      {title}:<p className="ml-1.5 font-bold">{content}</p>
    </p>
  );
};

export default function AgentsSameProduct({ }) {
  const [agentSameProduct, setAgentSameProduct] = useState([
    "",
    "",
    "",
    "",
    "",
  ]);
  const [searchParams] = useSearchParams();
  const drugId = searchParams.get("drugId");
  const [filterAddress, setfilterAddress] = useState(
    ListFilterAddress[0].value
  );

  const [filterPrice, setFilterPrice] = useState(ListFilterPrice[0].value);
  async function getAgentsSameProduct(drug_id, filter_address, filter_price) {
    const RESULT = await APIService.getAgentsSameProduct(
      1,
      10,
      drug_id,
      filter_address,
      filter_price
    );
    if (RESULT) {
      setAgentSameProduct(RESULT.data);
    }
  }
  useEffect(() => {
    getAgentsSameProduct(drugId, filterAddress, filterPrice);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drugId, filterAddress, filterPrice]);


  return (
    <>
      <div className="sm:flex justify-between">
        <h3 className="mt-3 sm:mt-0 mb-3 sm:mb-0 text-[14px] sm:text-[26px] font-bold">Đại lý bán cùng sản phẩm</h3>
        <div className="grid grid-cols-2 sm:flex wrap items-center gap-x-[10px] sm:gap-7 text-[10px] sm:text-sm">
          <span className="col-span-2">Sắp xếp theo</span>
          <Select
            showSearch
            placeholder="Giao hàng gần nhất"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setfilterAddress(value);
            }}
            value={filterAddress}
            className="font-semibold sm:w-[205px]
                    text-sm text-[#222222] not-italic outline-none"
          >
            {ListFilterAddress?.map((item) => (
              <Option value={item.value}>{item.lable}</Option>
            ))}
          </Select>
          <Select
            showSearch
            placeholder="Giá thấp đến cao"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setFilterPrice(value);
            }}
            value={filterPrice}
            className="font-semibold sm:w-[205px]
                    text-sm text-[#222222] not-italic outline-none"
          >
            {ListFilterPrice?.map((item) => (
              <Option value={item.value}>{item.lable}</Option>
            ))}
          </Select>
        </div>
      </div>
      <div className="h-6" />
      {agentSameProduct.map((item) => (
        <AgentsProductItem agentproduct={item} />
      ))}
    </>
  );
}
